import { defineMessages } from 'react-intl';

export default defineMessages({
    bundleCart: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Bundle Cart',
        defaultMessage: 'Bundle Cart'
    },
    bridgedQuotesSummary: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Bridged Quotes Summary',
        defaultMessage: 'Bridged Quotes Summary'
    },
    compRaterQuote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Comp Rater Quote',
        defaultMessage: 'Comp Rater Quote'
    },
    effectiveDate: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Effective date',
        defaultMessage: 'Effective date'
    },
    notReadyForPurchaseSectionHeader: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Select each bundle component to quote or edit',
        defaultMessage: 'Select each bundle component to quote or edit'
    },
    notReadyForPurchaseCompleteAll: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.You must complete all components to continue',
        defaultMessage: 'You must complete all components to continue'
    },
    notReadyForPurchaseTwoJobsMinimum: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.You must have at least two components to create a bundle',
        defaultMessage: 'You must have at least two components to create a bundle'
    },
    readyForPurchaseSectionHeader: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Quotes have been completed. Your bundle is ready to purchase',
        defaultMessage: 'Quotes have been completed. Your bundle is ready to purchase'
    },
    postQuoteSectionHeader: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Complete purchase information for each component',
        defaultMessage: 'Complete purchase information for each component'
    },
    addRemoveComponents: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.ADD/REMOVE PRODUCT',
        defaultMessage: 'ADD/REMOVE PRODUCT'
    },
    saveReturnAccount: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.SAVE & RETURN TO ACCOUNT',
        defaultMessage: 'SAVE & RETURN TO ACCOUNT'
    },
    createProposal: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.VIEW BUNDLE QUOTE',
        defaultMessage: 'VIEW BUNDLE QUOTE'
    },
    continueToPurchase: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.CONTINUE TO PURCHASE',
        defaultMessage: 'CONTINUE TO PURCHASE'
    },
    producerCodeAcknowledgementTitle: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.producerCodeAcknowledgementTitle',
        defaultMessage: 'Producer Code Updated'
    },
    producerCodechanged: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.producerCodechanged',
        defaultMessage: 'The selected producer code is not eligible for this quote. To continue, we have automatically changed the producer code to the agencys Primary Group Producer Code.'
    },
    producerCodechangedAdditionalText: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.producerCodechangedAdditionalText',
        defaultMessage: 'Select Continue to proceed or Cancel to choose a different producer code.'
    },
    producerCodechangedAssistanceText: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.producerCodechangedAssistanceText',
        defaultMessage: 'For assistance, contact Agency Contract Management at 1-800-237-6136.'
    },
    acknowledgeAndContinue: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.acknowledgeAndContinue',
        defaultMessage: 'ACKNOWLEDGE AND CONTINUE'
    },
    cancelModalBtn: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.cancelModalBtn',
        defaultMessage: 'Cancel'
    },
    issueBundle: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.ISSUE BUNDLE',
        defaultMessage: 'ISSUE BUNDLE'
    },
    continueToPurchaseMessage: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.We\'ll continue with your purchase next',
        defaultMessage: 'We\'ll <strong>continue</strong> with your purchase next'
    },
    completePurchaseMessage: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.We\'ll complete your purchase next',
        defaultMessage: 'We\'ll complete your <strong>purchase</strong> next'
    },
    issuePoliciesMessage: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.We\'ll issue your policies next',
        defaultMessage: 'We\'ll <strong>issue your policies</strong> next'
    },
    addComponentToContinue: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Add a component to continue',
        defaultMessage: '<strong>Add a component</strong> to continue'
    },
    backToEditQuotes: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Back to edit quotes',
        defaultMessage: 'Back to edit quotes'
    },
    issuesWithQuotesCorrectToProceed: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.There are issues with one or more of your quotes, please correct before you can proceed',
        defaultMessage: 'There are issues with one or more of your quotes, please correct before you can proceed'
    },
    RC: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.RC',
        defaultMessage: 'RC'
    },
    NRC: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.NRC',
        defaultMessage: 'NRC'
    },
    annual: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.YearTerm',
        defaultMessage: '/ year',
    },
    halfYear: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.6MonthsTerm',
        defaultMessage: '/ 6 month',
    },
    effective: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Effective',
        defaultMessage: 'Effective:',
    },
    status: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Status',
        defaultMessage: 'Status: ',
    },
    startQuote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.START QUOTE',
        defaultMessage: 'START QUOTE',
    },
    editQuote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.EDIT QUOTE',
        defaultMessage: 'EDIT QUOTE',
    },
    edit: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.EDIT',
        defaultMessage: 'EDIT',
    },
    requote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.REQUOTE',
        defaultMessage: 'REQUOTE',
    },
    completePurchaseInfo: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.COMPLETE PURCHASE INFO',
        defaultMessage: 'COMPLETE PURCHASE INFO',
    },
    editPurchaseInfo: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.EDIT PURCHASE INFO',
        defaultMessage: 'EDIT PURCHASE INFO',
    },
    viewQuote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.VIEW QUOTE',
        defaultMessage: 'VIEW QUOTE',
    },
    requoting: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Requoting...',
        defaultMessage: 'Requoting...',
    },
    retrievingBundle: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Retrieving bundle...',
        defaultMessage: 'Retrieving bundle...',
    },
    reminderCustomerPreviouslyQuoted: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Reminder: Your customer was previously quoted as part of a consolidation...',
        defaultMessage: 'Reminder: Your customer was previously quoted as a part of a consolidation.  If you would like to proceed or change the previously quoted policies, contact your consolidation manager.',
    },
    informationMayHaveChangedOnULPolicies: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Information may have been changed on one or more of the underlying policies...',
        defaultMessage: 'Information may have been changed on one or more of the underlying policies...',
    },
    packageIndicatorChangedRequote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Package Indicator has been changed. Please requote.',
        defaultMessage: 'Package Indicator has been changed. Please requote.',
    },
    policiesNeedRequote: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Policies in the bundle need to be requoted before proceeding.',
        defaultMessage: 'Policies in the bundle need to be requoted before proceeding.',
    },
    submissionHashtag: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Submission #',
        defaultMessage: 'Submission #',
    },
    genericErrorMessage: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Generic Error Message',
        defaultMessage: 'Due to technical issue, the bundle validation has failed. Please try again later or contact customer service for assistance.',
    },
    retrievingAccountDetails: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Retrieving account details...',
        defaultMessage: 'Retrieving account details...',
    },
    issuingBundledPolicies: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Issuing bundled policies..',
        defaultMessage: 'Issuing bundled policies..',
    },
    mlPeriodStartDatePopupTitle: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Please review the effective date as it’s a date in the past',
        defaultMessage: 'Please review the effective date as it’s a date in the past'
    },
    refreshingBundle: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Refreshing bundle...',
        defaultMessage: 'Refreshing bundle...'
    },
    error: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.error',
        defaultMessage: 'Error'
    },
    proposalError: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.proposalError',
        defaultMessage: 'Quote proposal document is not available yet. Please try again later.'
    },
    emailQuoteDescription: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.emailQuoteDescription',
        defaultMessage: 'Thank you. An email with your quote has been sent to {emailAddress_ML}'
    },
    exitModalTitle: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Are you sure you want to exit?',
        defaultMessage: 'Are you sure you want to exit?'
    },
    exitModalMessage: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.The information previously entered will be stored as a quote submission',
        defaultMessage: 'The information previously entered will be stored as a quote submission'
    },
    rateCapped: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Rate Capped',
        defaultMessage: 'Rate Capped'
    },
    nonRateCapped: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Non Rate Capped',
        defaultMessage: 'Non Rate Capped'
    },
    disclosureContentforKS:{
        id:'ml.gateway.quoteandbind.common.bundleCart.disclosureContentforKS',
        defaultMessage:"By continuing, you acknowledge that:\n"+
         "(1)you provided the below disclosure verbatim to the applicant(s) and notified them, including their spouse, that we and our affiliates consider both of their credit information in the underwriting and rating of their policy, and :\n"+
         "(2)you received an affirmative response to the requests for consent from the applicant.\n"+
         "In connection with this application for insurance, we may review your and your spouse’s credit report or obtain or use a credit-based insurance score based on the information contained in that credit report. We may use third parties in connection with the development of your insurance scores based on data from traditional credit bureaus and the National Consumer Telecom & Utilities Exchange database.  We provide an internal appeal process whereby you may review an adverse action based on your credit information. Also, if you believe an extraordinary life circumstance has negatively impacted your credit information, you may request, in writing, that we provide reasonable exceptions to our underwriting and/or rating practices. Please contact me for details on qualifying circumstances and how to request an exception.\n"
    },
    disclosureContentforStates:{
        id:'ml.gateway.quoteandbind.common.bundleCart.disclosureContentforStates',
        defaultMessage:"By continuing, you acknowledge that:\n" +
           "(1)  you provided the below disclosure verbatim to the applicant(s) and notified them, including their spouse, that we and our affiliates consider both of their credit information in the underwriting and rating of their policy, and:\n"+
           "(2)   you received an affirmative response to the requests for consent from the applicant.\n\n"+
           "In connection with this application for insurance, we may review your and your spouse’s credit report or obtain or use a credit-based insurance score based on the information contained in that credit report. We may use third parties in connection with the development of your insurance scores based on data from traditional credit bureaus and the National Consumer Telecom & Utilities Exchange database\n"
    },
    scriptHeader:{
        id:'ml.gateway.quoteandbind.common.bundleCart.scriptHeader',
        defaultMessage:"AGENT SCRIPT"
    },
     policyLockedExceptionMessage: {
        id:'ml.gateway.quoteandbind.common.bundleCart.policyLockedExceptionMessage',
        defaultMessage:"This policy is currently locked. Contact Underwriting to unlock policy"
    },
    somethingWentWrong: {
        id: 'ml.gateway.quoteandbind.common.bundleCart.Something went wrong during this process.Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    }
})